var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-layout d-flex flex-column",attrs:{"id":"app"}},[(_vm.isShow)?_c('app-header'):_vm._e(),_c('app-container',[_vm._t("default")],2),(_vm.footer && _vm.isShow)?_c('app-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }